import { TABLE_CONSTANTS } from './constants';
import { TableManipulationOptions } from './types';

function createTableInitialState(manipulationOptions?: TableManipulationOptions, pageSize?: number | null) {
  return {
    pagination: {
      pageIndex: manipulationOptions?.type === 'serverSide' ? manipulationOptions.currentPage : 0,
      pageSize: pageSize === null ? undefined : pageSize || TABLE_CONSTANTS.DEFAULT_PAGE_SIZE,
    },
  };
}

function createTableState(manipulationOptions?: TableManipulationOptions) {
  if (manipulationOptions?.type === 'clientSide') {
    return {
      columnFilters: manipulationOptions.filtersState,
      globalFilter: manipulationOptions.globalFilter,
    };
  }

  return {
    columnFilters: [],
    globalFilter: undefined,
    ...(manipulationOptions?.type === 'serverSide' && manipulationOptions.sorting
      ? { sorting: manipulationOptions.sorting }
      : {}),
  };
}

export { createTableInitialState, createTableState };
